import { Folder } from "domain/entities/folders.entities";
import { selectFolders } from "domain/folders/folders.selectors";
import { Dispatch, SetStateAction } from "react";
import { HiArrowLeft, HiFolder } from "react-icons/hi";
import { useAppSelector } from "ui/hook/store";
import { translate } from "ui/i18n";
import { FolderCard } from "ui/pages/app/my-creations/components/FolderCard";
import { useWindowWidth } from "ui/utils/hooks";

interface IProps {
  setSelectedFolder: (folder: Folder | null) => void;
  setIsFoldersOpen: Dispatch<SetStateAction<boolean>>;
}

export function FoldersPage({ setIsFoldersOpen, setSelectedFolder }: IProps) {
  const isDesktop = useWindowWidth();
  const folders = useAppSelector(selectFolders);

  const handleCardClick = (folder: Folder) => {
    setSelectedFolder(folder);
  };

  return (
    <div className="flex h-full flex-col p-4 md:flex-row md:py-8 md:pl-6 md:pr-10">
      <div className="mb-4 flex w-full items-center justify-between md:my-0 md:w-12 md:items-start">
        <div className="flex w-full items-center justify-between gap-4">
          <button
            onClick={() => setIsFoldersOpen(false)}
            className="z-50 flex h-5 items-center"
          >
            <HiArrowLeft size={24} className="text-darkGrey-800" />
          </button>
          <h1 className="text-base text-secondaryGrey-900 md:text-3xl">
            {translate("ns1:Folders.Folders")}
          </h1>
          <span className="w-6" />
        </div>
      </div>

      <div className="mt-4 w-full md:mt-8">
        {folders && folders.length > 0 ? (
          <div className="mb-8 mt-4 grid w-full grid-cols-1 gap-2 md:mt-8 md:gap-6 lg:grid-cols-3 xl:grid-cols-5">
            {folders.map((folder, index) => (
              <FolderCard
                folder={folder}
                key={"folder" + index}
                onClick={() => handleCardClick(folder)}
                row={!isDesktop}
              />
            ))}
          </div>
        ) : (
          <div className="mb-8 mt-4 flex w-fit items-center space-x-4 rounded-[20px] border-2 border-darkGrey-200 px-4 py-5 md:mt-8">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-darkGrey-200">
              <HiFolder size={24} color="#2B3674" />
            </div>
            <span className="text-sm font-medium text-darkGrey-700">
              {translate(`ns1:Folders.NoFolder`)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
